const naturalNumberPattern = /(^[1-9](\d+)$)|(^\d$)/;
const moreDecimalNumber3Pattern = /\.\d{3,}/; //小数点が3桁以上
const floatPattern = /^[+-]?(?:\d+\.?\d*|\.\d+)$/; //実数
const emailPattern =
  /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/;
const phonePattern= /^[0-9]{10,12}$/
const rule = (value: any, message: string) => {
  return { value: value, message: message };
};

export const floorValidation = {
  // required: rule(true, "この項目は必須です"),
  pattern: rule(naturalNumberPattern, "整数を入力してください"),
  min: rule(1, "建物の階数は1から60階を入力してください"),
  max: rule(60, "建物の階数は1から60階を入力してください"),
};

const areaValidation = {
  required: rule(true, "この項目は必須です"),
  pattern: rule(floatPattern, "半角数値を入力してください"),
  validate: {
    decimal: (value: string) => {
      return moreDecimalNumber3Pattern.test(value)
        ? "少数第二位までで指定してください"
        : true;
    },
  },
};

const livingAreaMessage = "居住面積は10以上800以下の値で入力してください";
export const livingAreaValidation = {
  ...areaValidation,
  min: rule(10, livingAreaMessage),
  max: rule(800, livingAreaMessage),
};

const landAreaMessage = "土地面積は50以上5000以下の値で入力してください";
export const landAreaValidation = {
  ...areaValidation,
  min: rule(50, landAreaMessage),
  max: rule(5000, landAreaMessage),
};

export const emailValidation = {
  pattern: rule(emailPattern, "メールアドレスの形式で入力してください"),
};

export const phoneValidation = {
  pattern: rule(phonePattern, "数値のみの電話番号の形式で入力してください"),
};

export const requiredValidation = {
  required: rule(true, "この項目は必須です"),
};
